<template>
    <div>

        <div class="position-relative">
            <!-- shape Hero -->
            <section class="section-shaped my-0">
                <div class="shape shape-style-3 shape-red shape-skew">
                    <span></span>
                    <span></span>
                    <span></span>
                    <span></span>
                    <span></span>
                    <span></span>
                    <span></span>
                    <span></span>
                    <span></span>
                </div>
                <div class="container shape-container d-flex">
                    <div class="col px-0">
                        <div class="row">
                            <div class="col-lg-6">
                                <h2 class="display-2  text-white">User Interface Graphics Design Tool
                                    <span>FlexDraw is provided with all 3Z FlexYard and FlexTrim</span>
                                </h2>
                                <p class="lead  text-white">that have workstations with a Windows OS. FlexDraw allows our customers to build their workstation graphics on their own. It’s a user friendly tool that technicians or engineers can use to add, remove, or modify switch, signal, or track layout. This tool allows our customers to make changes to their existing systems on their own, as yards are constantly evolving and new switches and tracks continue to be added. FlexDraweliminates costs to our customers when they need to make a simple change. It also allows our customers to keep pace with constant work load of new yard projects.</p>
                                <!-- <div class="btn-wrapper">
                                    <base-button tag="a"
                                                 href="https://demos.creative-tim.com/argon-design-system/docs/components/alerts.html"
                                                 class="mb-3 mb-sm-0"
                                                 type="info"
                                                 icon="fa fa-code">
                                        Components
                                    </base-button>
                                    <base-button tag="a"
                                                 href="https://www.creative-tim.com/product/argon-design-system"
                                                 class="mb-3 mb-sm-0"
                                                 type="white"
                                                 icon="ni ni-cloud-download-95">
                                        Download HTML
                                    </base-button>
                                </div> -->
                            </div>
                            <div class="col-md-5">
                                <div class="card bg-default shadow border-0">
                                    <div class="rounded overflow-hidden transform-perspective-right">
                                        <b-carousel class="carousel1"
                                                    controls
                                                    indicators>
                                            <!-- Text slides with image -->
                                            <b-carousel-slide img-src="img/3z/flexdraw1.png"></b-carousel-slide>
                                            <b-carousel-slide img-src="img/3z/flexdraw2.png"></b-carousel-slide>
                                            <b-carousel-slide img-src="img/3z/flexdraw3.png"></b-carousel-slide>
                                            <b-carousel-slide img-src="img/3z/flexdraw4.png"></b-carousel-slide>
                                        </b-carousel>
                                    </div>
                                    <blockquote class="card-blockquote">
                                        <svg preserveAspectRatio="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 583 95"
                                            class="svg-bg">
                                            <polygon points="0,52 583,95 0,95" class="fill-default"></polygon>
                                            <polygon points="0,42 583,95 683,0 0,95" opacity=".2" class="fill-default"></polygon>
                                        </svg>
                                        <icon name="ni ni-ruler-pencil" type="default" gradient="white" rounded class="mb-4">
                                        </icon>
                                        <h4 class="display-3 font-weight-bold text-white">Do It Yourself</h4>
                                        <p class="lead text-italic text-white">
                                            <ul class="list">
                                                <li>Draw Your Yard Layout</li>
                                                <li>Build Your Yard I/O Database</li>
                                                <li>Configure Layout with Database</li>
                                                <li>Deploy It…On Your Own!</li>
                                            </ul>
                                        </p>
                                        <div>
                                            <badge type="default" class="draw-badge" rounded>customizable</badge>
                                            <badge type="default" class="draw-badge" rounded>qt platform</badge>
                                            <badge type="default" class="draw-badge" rounded>web based</badge>
                                        </div>
                                    </blockquote>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            <!-- 1st Hero Variation -->
        </div>
        <!-- <section class="section section-lg">
            <div class="container">
                <div class="row justify-content-center text-center mb-lg">
                    <div class="col-lg-8">
                        <h2 class="display-3">3Z’s FlexDraw </h2>
                    </div>
                </div>
                <div class="row">
                    <div class="col-md-3 col-lg-3 mb-5 mb-lg-0">
                        <div class="px-4">
                            <img v-lazy="'img/3z/flexdraw1.png'"
                                 class="rounded img-center img-fluid shadow shadow-lg--hover">
                            <div class="pt-4 text-center">
                                <h5 class="title">
                                    <span class="d-block mb-1">Step #1</span>
                                    <small class="h6 text-muted">Customizable</small>
                                </h5>
                            </div>
                        </div>
                    </div>
                    <div class="col-md-3 col-lg-3 mb-5 mb-lg-0">
                        <div class="px-4">
                            <img v-lazy="'img/3z/flexdraw2.png'"
                                 class="rounded img-center img-fluid shadow shadow-lg--hover">
                            <div class="pt-4 text-center">
                                <h5 class="title">
                                    <span class="d-block mb-1">Step #2</span>
                                    <small class="h6 text-muted">Customizable</small>
                                </h5>
                            </div>
                        </div>
                    </div>
                    <div class="col-md-3 col-lg-3 mb-5 mb-lg-0">
                        <div class="px-4">
                            <img v-lazy="'img/3z/flexdraw3.png'"
                                 class="rounded img-center img-fluid shadow shadow-lg--hover">
                            <div class="pt-4 text-center">
                                <h5 class="title">
                                    <span class="d-block mb-1">Step #3</span>
                                    <small class="h6 text-muted">Customizable</small>
                                </h5>
                            </div>
                        </div>
                    </div>
                    <div class="col-md-3 col-lg-3 mb-5 mb-lg-0">
                        <div class="px-4">
                            <img v-lazy="'img/3z/flexdraw4.png'"
                                 class="rounded img-center img-fluid shadow shadow-lg--hover">
                            <div class="pt-4 text-center">
                                <h5 class="title">
                                    <span class="d-block mb-1">Step #4</span>
                                    <small class="h6 text-muted">Customizable</small>
                                </h5>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section> -->
        <section class="section section-lg">
            <div class="container">
                <div class="row row-grid justify-content-center">
                    <div class="col-lg-12 text-left">
                        <h2 class="display-2">Take Control: Building with Flexibility Results in Sustainability
                        </h2>
                    </div>
                    <div class="col-lg-12 text-left">
                        <p class="lead"> Technology continues to evolve faster and faster everyday. Unfortunately, so do the minds, strategies, and plans of railroad operating planners and personnel. This means that new capacity and capital project plans of a railroad are fluid and are constantly changing. As a railroad engineering employee, there are few tasks more difficult than planning projects and allocating resources to a plan that remains fluid.<br>
                        To solve this problem, you need to have the ability to keep up with the demand by minimizing project duration and resource effort required. How do you accomplish this?Start building with flexibility and gain sustainability. All of the products competing with FlexYard and FlexTrim today are built without adequate flexibility required for a railroad to sustain a system on its own. 3Z’s products are.<br>
                        </p>
                        <hr>
                        <p class="lead">FlexYard and FlexTrim are completely configured using MySQL databases. This allows all of the yard, I/O, comms, networking, logging and alarming to be easily re-configured or modified. Adding new hardware for new switches or track circuits requires more I/O, which can be added just like the existing I/O. Once the database is updated to accept the new equipment, it needs to be incorporated into the user interface. With 3Z’s FlexDraw, our customers can now add and modify the user workstation to display the new field equipment as they see fit. FlexDrawallows our customers to complete projects which require a modification of a yard system quickly, without delay or additional costs… On Their Own!</p>
                    </div>
                </div>
            </div>
        </section>

    </div>
</template>

<script>
import { BCarousel } from "bootstrap-vue/esm/components/carousel/carousel";
import { BCarouselSlide } from "bootstrap-vue/esm/components/carousel/carousel-slide";
export default {
  name: "Flexdraw",
  components: {
    BCarousel,
    BCarouselSlide
  }
};
</script>

<style scoped>
ul.list {
    padding-left: 1.2rem!important;
}
.carousel1 {
    height: 200px!important;
}
.draw-badge {
    background-color: #fff!important;
}
</style>